export default __webpack_public_path__ + "static/media/world-cup-banner.3faf510b.webp";